import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "my-3 w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold" }, "Eligibility", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "w-100"
}
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = {
  key: 0,
  class: "mt-1 mb-1 animated flash"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Checking Eligibility...", -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "big-text text-danger fw-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }),
  /*#__PURE__*/_createTextVNode(" Error retrieving eligibility ")
], -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "big-text text-success fw-bold"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Medicare ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "big-text text-danger fw-bold"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Medicare ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 2,
  class: "text-muted mb-0 mt-1"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Last Checked Today | ")
const _hoisted_24 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle" }, null, -1 /* HOISTED */)
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "list-unstyled ms-3 mt-1 mb-0" }
const _hoisted_31 = {
  key: 0,
  class: "text-danger mt-2 border p-2 bg-white"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1 /* HOISTED */)
const _hoisted_33 = ["href"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 1,
  class: "text-danger mt-2 border p-2 bg-white"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1 /* HOISTED */)
const _hoisted_37 = ["href"]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 2,
  class: "text-danger mt-2 border p-2 bg-white"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1 /* HOISTED */)
const _hoisted_41 = ["href"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 3,
  class: "text-danger mt-2 border p-2 bg-white"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1 /* HOISTED */)
const _hoisted_45 = ["href"]
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 4,
  class: "text-danger mt-2 border p-2 bg-white"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1 /* HOISTED */)
const _hoisted_49 = ["href"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = {
  key: 5,
  class: "text-danger mt-2 border p-2 bg-white"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1 /* HOISTED */)
const _hoisted_53 = ["href"]
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  key: 6,
  class: "text-danger mt-2 border p-2 bg-white"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1 /* HOISTED */)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, "Medicare eligibility can only be checked for patients who have a Medicare Number or Medicare Beneficiary Identifier (MBI) entered above. ", -1 /* HOISTED */)
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EligibilityPatientInfo = _resolveComponent("EligibilityPatientInfo")!
  const _component_EligibilityPayers = _resolveComponent("EligibilityPayers")!
  const _component_EligibilityHomeHealth = _resolveComponent("EligibilityHomeHealth")!
  const _component_EligibilityHospice = _resolveComponent("EligibilityHospice")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.firstName && _ctx.lastName && _ctx.gender && _ctx.locationId && _ctx.dateOfBirth && _ctx.eligibilityNumber)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isCheckingEligibility)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _hoisted_7))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.eligibility)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_ctx.eligibility.request_Result.success !== 'Yes')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_12))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                              (_ctx.eligibility.medicare_Part_A.success == 'Yes')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
                                : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
                            ])),
                        _createElementVNode("button", {
                          class: "btn btn-xs btn-primary ms-3",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkEligibility()))
                        }, "Check Again"),
                        (_ctx.eligibility.request_Result.success === 'Yes')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                              _hoisted_23,
                              (!_ctx.isReportExpanded)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: "#",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showReport()))
                                  }, "View Latest Report"))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: "#",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideReport()))
                                  }, "Hide Report"))
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.isReportExpanded && _ctx.eligibility.request_Result.success == 'Yes')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createVNode(_component_EligibilityPatientInfo, { eligibility: _ctx.eligibility }, null, 8 /* PROPS */, ["eligibility"]),
                              _createVNode(_component_EligibilityPayers, { eligibility: _ctx.eligibility }, null, 8 /* PROPS */, ["eligibility"]),
                              _createVNode(_component_EligibilityHomeHealth, { eligibility: _ctx.eligibility }, null, 8 /* PROPS */, ["eligibility"]),
                              _createVNode(_component_EligibilityHospice, { eligibility: _ctx.eligibility }, null, 8 /* PROPS */, ["eligibility"])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_ctx.firstName && _ctx.lastName && _ctx.gender && _ctx.locationId && _ctx.dateOfBirth && _ctx.eligibilityNumber)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-primary",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkEligibility()))
                            }, " Check Eligibility "))
                          : _createCommentVNode("v-if", true)
                      ]))
                ]))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _hoisted_27,
          (!_ctx.eligibilityNA)
            ? (_openBlock(), _createElementBlock("b", _hoisted_28, "Enter the following fields to check Medicare eligibility:"))
            : (_openBlock(), _createElementBlock("b", _hoisted_29, "N/A- Not Applicable")),
          _createElementVNode("ul", _hoisted_30, [
            (!_ctx.firstName)
              ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                  _hoisted_32,
                  (_ctx.missingUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.missingUrl.firstName,
                        class: "cursor-pointer"
                      }, "First Name", 8 /* PROPS */, _hoisted_33))
                    : (_openBlock(), _createElementBlock("span", _hoisted_34, "First Name"))
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.lastName)
              ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                  _hoisted_36,
                  (_ctx.missingUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.missingUrl.lastName,
                        class: "cursor-pointer"
                      }, "Last Name", 8 /* PROPS */, _hoisted_37))
                    : (_openBlock(), _createElementBlock("span", _hoisted_38, "Last Name"))
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.gender)
              ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                  _hoisted_40,
                  (_ctx.missingUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.missingUrl.gender,
                        class: "cursor-pointer"
                      }, "Gender", 8 /* PROPS */, _hoisted_41))
                    : (_openBlock(), _createElementBlock("span", _hoisted_42, "Gender"))
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.dateOfBirth)
              ? (_openBlock(), _createElementBlock("li", _hoisted_43, [
                  _hoisted_44,
                  (_ctx.missingUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.missingUrl.dateOfBirth,
                        class: "cursor-pointer"
                      }, "Date of Birth", 8 /* PROPS */, _hoisted_45))
                    : (_openBlock(), _createElementBlock("span", _hoisted_46, "Date of Birth"))
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.locationId)
              ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                  _hoisted_48,
                  (_ctx.missingUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.missingUrl.locationId,
                        class: "cursor-pointer"
                      }, "Agency Branch", 8 /* PROPS */, _hoisted_49))
                    : (_openBlock(), _createElementBlock("span", _hoisted_50, "Agency Branch"))
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.eligibilityNumber && !_ctx.eligibilityNA)
              ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                  _hoisted_52,
                  (_ctx.missingUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.missingUrl.medicareNumber,
                        class: "cursor-pointer"
                      }, " Medicare Beneficiary Identifier (MBI) or Medicare Number ", 8 /* PROPS */, _hoisted_53))
                    : (_openBlock(), _createElementBlock("span", _hoisted_54, " Medicare Beneficiary Identifier (MBI) or Medicare Number"))
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.eligibilityNA)
              ? (_openBlock(), _createElementBlock("li", _hoisted_55, _hoisted_58))
              : _createCommentVNode("v-if", true)
          ])
        ]))
  ]))
}